import { ButtonModule } from '@uzurv/afp/button';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { UzurvDirectivesModule, UzurvPipesModule } from '@uzurv/core';
import { RequiresPermissionsModule } from '../directives';
import { RideStatusChipModule } from './../ride-status-chip/ride-status-chip.module';
import { TripIdDetailComponent } from './trip-id-detail.component';


@NgModule({
  declarations: [TripIdDetailComponent],
  imports: [
    ButtonModule,
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatRippleModule,
    MatChipsModule,
    MatMenuModule,
    MatSnackBarModule,
    RequiresPermissionsModule,
    RideStatusChipModule,
    UzurvDirectivesModule,
    UzurvPipesModule
  ],
  exports: [TripIdDetailComponent]
})
export class TripIdDetailModule {}
